/**
 * Collapse duplicate client labels in filter dropdowns (case-insensitive).
 * When options use numeric client ids, keeps the lowest id per name.
 */
export function dedupeClientFilterOptions(options) {
  if (!Array.isArray(options) || options.length === 0) return [];

  const bestByLabel = new Map();

  for (const opt of options) {
    if (!opt || opt.value == null) continue;
    const label = String(opt.label ?? opt.value).trim();
    if (!label) continue;

    const key = label.toLowerCase();
    const existing = bestByLabel.get(key);
    if (!existing) {
      bestByLabel.set(key, opt);
      continue;
    }

    const idNum = Number(opt.value);
    const existingId = Number(existing.value);
    if (
      Number.isFinite(idNum) &&
      Number.isFinite(existingId) &&
      idNum < existingId
    ) {
      bestByLabel.set(key, opt);
    }
  }

  return [...bestByLabel.values()];
}
